/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'fm-date-ago-display',
  templateUrl: './date-ago-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateAgoDisplayComponent {

  timeUnit: 'seconds' | 'minutes' | 'hours' | 'days' | 'months' | 'years';
  numberOfTimeUnits: number;

  @Input() set date(value: Date) {
    const now = Date.now();
    const diffInSeconds = (now - value.getTime()) / 1000;

    const minutes = (noOfMinutes: number) => noOfMinutes * 60;
    const hours = (noOfHours: number) => noOfHours * 3600;
    const days = (noOfDays: number) => noOfDays * 86400;
    const months = (noOfMonths: number) => noOfMonths * 2592000;
    const years = (noOfYears: number) => noOfYears * 31556952;

    if (diffInSeconds < 45) {
      this.timeUnit = 'minutes';
      this.numberOfTimeUnits = 0;
    } else if (diffInSeconds >= 45 && diffInSeconds < minutes(45)) {
      this.timeUnit = 'minutes';
      const noOfMinutes = Math.round(diffInSeconds / minutes(1));
      this.numberOfTimeUnits = noOfMinutes;
    } else if (diffInSeconds >= minutes(45) && diffInSeconds < hours(22)) {
      this.timeUnit = 'hours';
      const noOfHours = Math.round(diffInSeconds / hours(1));
      this.numberOfTimeUnits = noOfHours;
    } else if (diffInSeconds >= hours(22) && diffInSeconds < days(26)) {
      this.timeUnit = 'days';
      const noOfDays = Math.round(diffInSeconds / days(1));
      this.numberOfTimeUnits = noOfDays;
    } else if (diffInSeconds >= days(26) && diffInSeconds < days(320)) {
      this.timeUnit = 'months';
      const noOfMonths = Math.round(diffInSeconds / months(1));
      this.numberOfTimeUnits = noOfMonths;
    } else if (diffInSeconds >= days(320)) {
      this.timeUnit = 'years';
      const noOfYears = Math.round(diffInSeconds / years(1));
      this.numberOfTimeUnits = noOfYears;
    }
  }
}
